// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-resources-checkboxes-holder[data-v-21cc357b] {\n  border: 1px solid #f1f3f6;\n  padding: 15px;\n  border-radius: 3px;\n  margin-bottom: 20px;\n}\n.heading[data-v-21cc357b] {\n  display: flex;\n  justify-content: space-between;\n}\n.separator[data-v-21cc357b] {\n  border-bottom: 1px solid #f1f3f6;\n  margin-top: 10px;\n  margin-bottom: 25px;\n}\n.resources-checkbox[data-v-21cc357b] {\n  margin: 0;\n}\n.child-resources[data-v-21cc357b] {\n  margin-left: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
